import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'si-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss']
})
export class DeleteButtonComponent {
  @Input() icon = 'icon-bin';
  @Input() text: string;
  @Input() styleClass = 'si-button_link-danger align-items-center';
  @Input() tooltip: string;
  @Input() tooltipPosition = 'top';
  @Input() path: string;
  @Input() dialogTitle: string;
  @Input() dialogTitleStyleClass = 'generic-dialog_title_alert mb-3';
  @Input() dialogText: string;
  @Input() putMethod = false;
  @Input() button1Text = 'SI_YES_DELETE';
  @Input() button1Class = 'si-button_alert';
  @Input() button2Text = 'SI_NO_CANCEL';
  @Input() button2Class = 'si-button_secondary';
  @Output() updateChange = new EventEmitter<any>();
  displayDialog = false;

  constructor(private http: HttpClient) {
  }

  onClickButton(event: Event): void {
    event.stopPropagation();
    this.displayDialog = true;
  }

  async onClickCloseDialog(action: boolean): Promise<any> {
    if (action) {
      await this.deleteItem();
      this.updateChange.emit();
    }

    this.displayDialog = false;
  }

  async deleteItem(): Promise<any> {
    if (!this.path) {
      return;
    }

    if (this.putMethod) {
      await this.http.put(this.path, {}).toPromise();
    } else {
      await this.http.delete(this.path).toPromise();
    }
  }

  onChangeDisplayDialog(displayDialog: boolean): void {
    this.displayDialog = displayDialog;
  }
}
